import { RefinementCtx } from 'zod';
import { YYYYMMDDToLabel } from './formattingUtils.ts';

const months = {
  1: { days: 31, name: 'January' },
  2: { days: 29, name: 'February' },
  3: { days: 31, name: 'March' },
  4: { days: 30, name: 'April' },
  5: { days: 31, name: 'May' },
  6: { days: 30, name: 'June' },
  7: { days: 31, name: 'July' },
  8: { days: 31, name: 'August' },
  9: { days: 30, name: 'September' },
  10: { days: 31, name: 'October' },
  11: { days: 30, name: 'November' },
  12: { days: 31, name: 'December' },
};

const stringContainsOnlyNumbers = (str: string) => /^\d+$/.test(str);

export const validateDate = (date: string, ctx: RefinementCtx) => {
  const { day, month, year } = YYYYMMDDToLabel(date);

  if (!stringContainsOnlyNumbers(day) || !stringContainsOnlyNumbers(month) || !stringContainsOnlyNumbers(year)) {
    ctx.addIssue({
      code: 'custom',
      message: 'Date should only contain numbers',
    });
    return;
  }

  const parsedDay = parseInt(day, 10);
  const monthNumber = parseInt(month, 10);
  const parsedYear = parseInt(year, 10);

  if (parsedYear > 3000 || parsedYear < 1900) {
    ctx.addIssue({
      code: 'custom',
      message: 'Please enter a valid date, for example 20/08/2024 using YYYY format',
    });
    return;
  }

  if (monthNumber > 12 || monthNumber < 1) {
    ctx.addIssue({
      code: 'custom',
      message: 'Please enter a valid month between 1 and 12',
    });
    return;
  }

  if (parsedDay > months[monthNumber as keyof typeof months]?.days || parsedDay < 1) {
    ctx.addIssue({
      code: 'custom',
      message: `Please enter a valid day for ${months[monthNumber as keyof typeof months].name}`,
    });
  }
};

export const isValidInternalPath = (path: string): boolean => path.startsWith('/')
    && !path.includes('//')
    && !path.startsWith('//')
    && path.length > 1
    && path.length < 2048;
